import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { useT } from '_metronic/i18n/Metronici18n'
import { PageTitle } from '../../../../_metronic/layout/core'
import { SncrBlocosListPage } from './blocos/SncrBlocosListPage'

/** Numeração SNCR (Anvisa) do profissional: blocos retirados e saldo por empresa de vínculo. */
const SncrPage = () => {
  const { t } = useT()

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='lista'
          element={
            <>
              <PageTitle description={t('sncr.lista.descricao')}>
                {t('sncr.lista.titulo')}
              </PageTitle>
              <SncrBlocosListPage />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/sncr/lista' />} />
    </Routes>
  )
}

export default SncrPage
